export function sortArrayByCriterion(arr, sortCriterion, order = 'asc') {
  return arr.sort((a, b) => {
    if (a[sortCriterion] > b[sortCriterion]) return order === 'asc' ? 1 : -1;
    if (a[sortCriterion] < b[sortCriterion]) return order === 'asc' ? -1 : 1;
    return 0;
  });
}
